module.exports = __webpack_public_path__ + "static/media/translations.f699a52c.csv";